import { HTMLAttributes, memo } from 'react';

type Options = {
  fractionDigits?: number;
  notation?: 'standard' | 'compact';
};

type MoneyProps = HTMLAttributes<HTMLSpanElement> & {
  value: number | string;
  currency?: string;
  plus?: boolean;
  fractionDigits?: number;
  compact?: boolean;
};

export const formatMoney = (
  value: number | string,
  currencyCode = 'USD',
  options: Options = {},
) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: options.fractionDigits ?? 2,
    style: 'currency',
    currency: currencyCode,
    notation: options.notation ?? 'standard',
  });

  return formatter.format(Number(value));
};

function Money({
  value,
  currency = 'USD',
  plus = false,
  fractionDigits = 2,
  compact = false,
  ...rest
}: MoneyProps) {
  const numValue = Number(value);

  return (
    <span {...rest}>
      {plus && numValue > 0 ? '+' : null}
      {formatMoney(numValue, currency, {
        fractionDigits,
        notation: compact ? 'compact' : 'standard',
      })}
    </span>
  );
}

export default memo(Money);
